import React, { createContext, useContext, useState } from "react";
import { AXIOS } from "./network";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const handleCognitoVerification = async (cognitoUserId, email) => {

        const payload = {
            cognitoUserId: cognitoUserId,
            email: email,

        };
        // localStorage.setItem("refreshToken", decode.refreshToken);
        try {
            const response = await AXIOS.post(
                `https://chatapi.nte.ai/v3/user/verifyCognito`,
                // `https://chatstagingapi.nte.ai/user/verifyCognito`,
                // `http://172.16.5.25:3005/v2/user/verifyCognito`,


                payload
            );

            if (response.data.status === 'success') {
                localStorage.setItem('authToken', response.data.token);
                // localStorage.setItem("refreshToken", decode.refreshToken);
                localStorage.setItem("authUser", response.data._id);

            } else {
                console.error('Something went worng');
            }
        } catch (error) {
            console.error("Cognito Verification Error:", error);
        }
    };
    return (
        <AuthContext.Provider value={{ handleCognitoVerification }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
